import { render } from "./Teamoverview.vue?vue&type=template&id=45ba420f&scoped=true"
import script from "./Teamoverview.vue?vue&type=script&lang=js"
export * from "./Teamoverview.vue?vue&type=script&lang=js"

import "./Teamoverview.vue?vue&type=style&index=0&id=45ba420f&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45ba420f"]])

export default __exports__